import { createRoute, useNavigate } from "@tanstack/react-router";
import { workspaceRoute } from "../shell/routes";
import { InboxPage } from "./InboxPage";
import { resetsScroll } from "./list-scroll";
import { InboxSearch } from "./scope";

/** Unified inbox (WP-007): scope, filters, search, conversation and keyboard triage, all in the URL. */
export const inboxRoute = createRoute({
  getParentRoute: () => workspaceRoute,
  path: "inbox",
  validateSearch: (raw: Record<string, unknown>): InboxSearch => InboxSearch.parse(raw),
  component: function Inbox() {
    const { workspaceId } = inboxRoute.useParams();
    const search = inboxRoute.useSearch();
    const navigate = useNavigate({ from: inboxRoute.fullPath });
    return (
      <InboxPage
        key={workspaceId}
        workspaceId={workspaceId}
        search={search}
        onSearch={(patch) => void navigate({ search: (prev) => ({ ...prev, ...patch }), resetScroll: resetsScroll(patch) })}
      />
    );
  },
});
